export default __webpack_public_path__ + "static/media/elec-services.477848a9.jpg";